import * as React from 'react';

import { IRatingSection } from '../../types/rating';
import { RatingDetail } from '../RatingDetail';
import * as style from './NewbuildingRatings.css';

export interface INewbuildingRatingsProps {
  sections: IRatingSection[];
}

export const NewbuildingRatings: React.FC<INewbuildingRatingsProps> = props => {
  const { sections } = props;

  return (
    <div data-testid="NewbuildingRatings" className={style['container']}>
      <ul className={style['list']}>
        {sections.map(({ name, rating, type }) => (
          <li className={style['item']} key={type}>
            <RatingDetail name={name} value={rating} />
          </li>
        ))}
      </ul>
    </div>
  );
};
